<template>
  <div>
    <div class="t_h1">
      <div class="t_h1_top">{{ $t("main.text322") }}</div>
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top" :model="form">
          <el-form-item>
            <el-input
              v-model="form.content"
              :placeholder="$t('bank_card.username_email')"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-select v-model="form.status" :placeholder="$t('bank_card.Subaccount_status')">
              <el-option :label="$t('bank_card.start')" :value="20"></el-option>
              <el-option :label="$t('bank_card.forbidden')" :value="30"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>

        </el-form>
        <!-- <el-form>
          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>
        </el-form> -->
      </div>
    </div>

    <div class="transaction_h">
      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">{{$t('bank_card.in_all')}} {{ count || 0 }} {{$t('bank_card.Bar_data')}}</div>
          </div>
        </div>

        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column type="index" width="50"></el-table-column>

            <el-table-column :label="$t('bank_card.User_name_subaccount')">
              <span slot-scope="props">
                <div>{{ props.row.username }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Subaccount_mailbox')">
              <span slot-scope="props">
                <div>{{ props.row.email }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Subaccount_status')">
              <span slot-scope="props">
                <!-- "status": 20启动；30禁用, -->
                <div v-if="props.row.status==20">{{$t('bank_card.start')}}</div>
                <div v-else-if="props.row.status==30">{{$t('bank_card.forbidden')}}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.group_name')">
              <span slot-scope="props">
                <div>{{ props.row.title||"-" }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.describe')">
              <span slot-scope="props">
                <div>{{ props.row.desc||"-" }}</div>
              </span>
            </el-table-column>

            <!-- <el-table-column :label="$t('bank_card.operation')">
              <span slot-scope="props">
                <div>{{ props.row.balance }}</div>
                <span @click="to_info(props.row.authjson)" class="authjson_btn">{{$t('bank_card.permission_view')}}</span>
              </span>
            </el-table-column> -->

          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="count"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { childList } from "@/api/api";

export default {
  data() {
    return {
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      count: 0, //一共多少条
      tableData: [],
      form: {
        content: "",
        status: "",
      },
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", this.$t('bank_card.Ass_management'));
    this.get_list();
  },
  methods: {
    get_list() {
      childList({
        userid:sessionStorage.getItem("userid"),
        searchContent: this.form.content,
        status: this.form.status,
        page: this.page,
        limit: this.limit,
      }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data.list);
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });
    },
    current_change(v) {
      this.page = v;
      this.limit = 10;
      this.get_list();
    },

    to_info(authjson) {
      sessionStorage.setItem("info_authjson",JSON.stringify(authjson));
      this.$router.push({ path: "/concealed_accounts_info" });
    },

    reset_btn() {
      this.form.content = "";
      this.form.status = "";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
  },
};
</script>
  
  <style scoped>
.t_h1_top {
  /* margin-top: 40px; */
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red {
  color: #f35f65;
}
.zdy_tab_header >>> .el-table tr th:last-child,
.zdy_tab_header >>> .el-table__body tr td:last-child {
  padding-left: 0 !important;
}
.btn_icon {
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1 {
  height: 32px;
  border: 1px solid #deb981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2 {
  height: 32px;
  border: 1px solid #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ff4646;
  background: transparent;
  margin-top: 10px;
}
.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active {
  background: #f35f65;
  border-color: #f35f65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}
.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}
.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text5_2:nth-child(8) {
  padding-top: 10px;
}
.top_text5_2 {
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7 {
  /* padding: 18px 12px 20px;
    background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.div_num {
  flex: 1;
  background: #223c58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2 {
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}
.top_text8 {
  display: flex;
  margin-top: 12px;
}
.top_text8 > div {
  width: 50%;
}
.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow {
  background: #e8dac8;
}
.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}
.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}
.top_up_link {
  color: #041728;
  text-decoration: underline;
}
</style>
  
  <style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell {
  background: #172c43 !important;
}
.cards_table .row_2_bgc:hover {
  background: #172c43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell {
  background: #172c43 !important;
}
/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text {
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.authjson_btn{
    cursor: pointer;
    color: #1890FF;
}
</style>
  
  <style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
}
</style>
  